(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/system-huxflux-box.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/system-huxflux-box.js');

'use strict';

const focusElement = svs.numbergames.core.utils.ui.focusElement;
const updatePossibleCombination = _ref => {
  let manualSize = _ref.manualSize,
    combination = _ref.combination,
    getLimitsFunction = _ref.getLimitsFunction;
  const _getLimitsFunction = getLimitsFunction({
      rules: svs.numbergames.game_model.rulesRadio.request('rules'),
      combinationSize: combination.manualSize
    }),
    maxCombination = _getLimitsFunction.max;
  const _getLimitsFunction2 = getLimitsFunction({
      rules: svs.numbergames.game_model.rulesRadio.request('rules'),
      combinationSize: combination.selected
    }),
    selectedMinCombination = _getLimitsFunction2.min,
    selectedMaxCombination = _getLimitsFunction2.max;
  const minHuxfluxable = combination.manualSize === combination.selected ? manualSize + 1 : 0;
  return {
    min: Math.max(manualSize, selectedMinCombination, minHuxfluxable),
    max: Math.min(maxCombination, selectedMaxCombination)
  };
};
const isDisabled = (value, _ref2) => {
  let min = _ref2.min,
    max = _ref2.max;
  return value < min || value > max;
};
const radioNodeListValue = (radioNodeList, value) => {
  if (radioNodeList) {
    if (value) {
      radioNodeList.value = value;
    } else {
      value = parseInt(radioNodeList.value, 10);
    }
  }
  return value || 0;
};
svs.numbergames.game.views.SystemHuxfluxBox = Marionette.View.extend({
  tagName: 'form',
  regions: {
    huxfluxSystemDescriptionRegion: '#huxfluxSystemDescriptionRegion'
  },
  ui: {
    huxfluxNumber: '.js-number-selector',
    huxfluxNumberDisabled: '.js-number-selector:disabled',
    huxfluxNumberLabel: '.js-number-label',
    huxfluxNumberExtra: '.js-number-extra-selector',
    huxfluxNumberExtraLabel: '.js-number-extra-label',
    huxfluxBtn: '.js-huxflux-popover-btn'
  },
  triggers: {
    'click @ui.huxfluxNumberLabel': {
      event: 'numberClicked',
      preventDefault: false
    },
    'click @ui.huxfluxNumberExtraLabel': {
      event: 'numberExtraClicked',
      preventDefault: false
    },
    'keydown @ui.huxfluxNumber': {
      event: 'keydownNumberSize',
      preventDefault: false,
      stopPropogation: false
    },
    'change @ui.huxfluxNumber': 'changedNumberSize',
    'change @ui.huxfluxNumberExtra': 'changedNumberExtraSize',
    'click @ui.huxfluxBtn': 'startHuxflux'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
    channel: svs.numbergames.game.huxfluxRadio
  }],
  template(data) {
    return svs.numbergames.game.templates.system_huxflux_box(data);
  },
  templateContext() {
    const rules = svs.numbergames.game_model.rulesRadio.request('rules');
    const _ref3 = rules ? rules.SYSTEM.LIMITS : {},
      NUMBERS = _ref3.NUMBERS,
      NUMBERS_EXTRA = _ref3.NUMBERS_EXTRA;
    if (!this.model.has('numbersExtra')) {
      const manual = this.model.get('numbers').getManualNumbersLength();
      if (this.model.has('level')) {
        const minLimits = Object.keys(NUMBERS.combinationMinLength);
        const maxLimits = Object.keys(NUMBERS.combinationMaxLength);
        const level = this.model.get('level');
        return {
          numbersLimit: {
            minRowLength: NUMBERS.combinationMinLength[minLimits[0]],
            maxRowLength: NUMBERS.combinationMaxLength[maxLimits[maxLimits.length - 1]]
          },
          disabledIf: value => value <= manual || value <= level
        };
      }
      return {
        numbersLimit: NUMBERS,
        disabledIf: value => value <= manual
      };
    }
    const manual = this.model.get('numbers').getManualNumbersLength();
    const manualExtra = this.model.get('numbersExtra').getManualNumbersLength();
    const _svs$numbergames$rule = svs.numbergames.rules.system.systemLimits({
        rules: svs.numbergames.game_model.rulesRadio.request('rules'),
        numberSize: manual,
        numberExtraSize: manualExtra
      }),
      numbersLimits = _svs$numbergames$rule.numbersLimits,
      numbersExtraLimits = _svs$numbergames$rule.numbersExtraLimits;
    const extraNumberType = {
      EUROJACKPOT: 'stjärnnummer',
      VIKINGLOTTO: 'vikingnummer'
    };
    return {
      numbersLimit: NUMBERS,
      disabledIf: value => isDisabled(value, {
        min: manual,
        max: numbersLimits.max
      }),
      numbersExtraLimit: NUMBERS_EXTRA,
      extraDisabledIf: value => isDisabled(value, {
        min: manualExtra,
        max: numbersExtraLimits.max
      }),
      extraNumberType: extraNumberType[this.model.get('productId')]
    };
  },
  numbersSelection(value) {
    return radioNodeListValue(this.el.elements['huxflux-main-radio-group'], value);
  },
  numbersExtraSelection(value) {
    return radioNodeListValue(this.el.elements['huxflux-markedextra-radio-group'], value);
  },
  onStartHuxflux() {
    this.radio.trigger('huxflux:start', this.model, this.numbersSelection(), this.numbersExtraSelection());
  },
  onKeydownNumberSize(view, event) {
    if (!this.model.has('numbersExtra')) {
      let step = 0;
      switch (event.key) {
        case 'ArrowUp':
        case 'ArrowRight':
          step = 1;
          break;
        case 'ArrowDown':
        case 'ArrowLeft':
          step = -1;
          break;
        case 'Enter':
        case ' ':
          this.el.elements['huxflux-main-radio-group'].value = event.target.value;
          this.triggerMethod('changedNumberSize');
          break;
        default:
          this.radio.trigger('huxflux:hidePopover');
          return;
      }
      event.preventDefault();
      event.stopPropagation();
      const numbers = this.getUI('huxfluxNumber');
      const numbersDisabled = this.getUI('huxfluxNumberDisabled');
      const startIndex = numbersDisabled.length;
      const index = numbers.index(event.target) + step;
      if (index < startIndex) {
        focusElement(numbers.last());
      } else if (index >= numbers.length) {
        focusElement(numbers[startIndex]);
      } else {
        focusElement(numbers[index]);
      }
    }
  },
  onChangedNumberSize() {
    if (!this.model.has('numbersExtra')) {
      this.triggerMethod('startHuxflux');
      return;
    }
    const selections = updatePossibleCombination({
      productId: this.model.get('productId'),
      manualSize: this.model.get('numbersExtra').getManualNumbersLength(),
      combination: {
        manualSize: this.model.get('numbers').getManualNumbersLength(),
        selected: this.numbersSelection()
      },
      getLimitsFunction: svs.numbergames.rules.system.systemNumbersExtraLimits
    });
    $(this.getUI('huxfluxNumberExtra')).each((i, el) => {
      el.disabled = isDisabled(parseInt(el.value, 10), selections);
    });
    if (selections.max === selections.min) {
      if (this.numbersExtraSelection() !== selections.min) {
        this.numbersExtraSelection(selections.min);
        this.triggerMethod('changedNumberExtraSize');
      }
    }
    this.checkValidSelections();
  },
  onChangedNumberExtraSize() {
    const selections = updatePossibleCombination({
      productId: this.model.get('productId'),
      manualSize: this.model.get('numbers').getManualNumbersLength(),
      combination: {
        manualSize: this.model.get('numbersExtra').getManualNumbersLength(),
        selected: this.numbersExtraSelection()
      },
      getLimitsFunction: svs.numbergames.rules.system.systemNumbersLimits
    });
    $(this.getUI('huxfluxNumber')).each((i, el) => {
      el.disabled = isDisabled(parseInt(el.value, 10), selections);
    });
    if (selections.max === selections.min) {
      if (this.numbersSelection() !== selections.min) {
        this.numbersSelection(selections.min);
        this.triggerMethod('changedNumberSize');
      }
    }
    this.checkValidSelections();
  },
  checkValidSelections() {
    const numberSize = this.numbersSelection();
    const numberExtraSize = this.numbersExtraSelection();
    const manualNumbersLength = this.model.get('numbers').getManualNumbersLength();
    const manualNumbersExtraLength = this.model.get('numbersExtra').getManualNumbersLength();
    const isValid = numberSize && numberExtraSize && !(numberSize === manualNumbersLength && numberExtraSize === manualNumbersExtraLength);
    this.getUI('huxfluxBtn').attr('disabled', !isValid);
    const _svs$numbergames$game = svs.numbergames.game_model.rulesRadio.request('rules'),
      numbersMaxLength = _svs$numbergames$game.numbersMaxLength,
      numbersExtraMaxLength = _svs$numbergames$game.numbersExtraMaxLength;
    const rowCount = svs.numbergames.rules.system.generatedRows({
      numbersLength: numberSize,
      numbersExtraLength: numberExtraSize,
      numbersRowSize: numbersMaxLength,
      numbersExtraRowSize: numbersExtraMaxLength
    });
    if (isValid) {
      this.showChildView('huxfluxSystemDescriptionRegion', {
        tagName: 'p',
        className: 'align-center js-system-summary popover-title popover-title-summary',
        template() {
          return svs.numbergames.rules.system.systemDescription({
            rowCount,
            numbersLength: numberSize,
            numbersExtraLength: numberExtraSize
          });
        }
      });
    } else if (this.getChildView('huxfluxSystemDescriptionRegion')) {
      this.getChildView('huxfluxSystemDescriptionRegion').destroy();
    }
  },
  onNumberClicked(view, event) {
    this.selectionClicked(view, event, 'changedNumberSize');
  },
  onNumberExtraClicked(view, event) {
    this.selectionClicked(view, event, 'changedNumberExtraSize');
  },
  selectionClicked(view, event, triggerEvent) {
    if (event.target.control.checked) {
      event.target.control.checked = false;
      event.preventDefault();
      this.triggerMethod(triggerEvent);
    }
  }
});

 })(window);